import React from "react";
import { Row, Col, Form } from "react-bootstrap";
import SelectDropDown from "../../selectdropdown/SelectDropDown";

function AnalyticsFilters({
    search,
    onSearchChange,
    classOptions,
    classId,
    onClassChange,
    sectionOptions,
    sectionIds,
    onSectionChange,
    subjectOptions,
    subjectId,
    onSubjectChange,
    attendance,
    onAttendanceChange,
    passFail,
    onPassFailChange,
    quickFilter,
    onQuickFilterChange,
    onExportCsv,
    onExportExcel,
    onPrint,
}) {
    const selectedSectionOptions = sectionOptions.filter((o) => sectionIds.includes(String(o.value)));

    return (
        <div style={{ padding: "12px 20px", background: "#f8fafc", borderBottom: "1px solid #e5e7eb" }}>
            <Row className="g-2 align-items-end">
                <Col xs={12} sm={6} md={3} lg={2}>
                    <Form.Label className="mb-1" style={{ fontSize: 12, fontWeight: 600 }}>Search Student</Form.Label>
                    <Form.Control
                        type="text"
                        size="sm"
                        placeholder="Search by name..."
                        value={search}
                        onChange={(e) => onSearchChange(e.target.value)}
                    />
                </Col>
                <Col xs={12} sm={6} md={3} lg={2}>
                    <Form.Label className="mb-1" style={{ fontSize: 12, fontWeight: 600 }}>Class</Form.Label>
                    <SelectDropDown
                        name="analyticsClass"
                        placeholderName="All Classes"
                        options={classOptions}
                        stateData={classId ? classOptions.find((c) => String(c.value) === String(classId)) || null : null}
                        handleChange={(name, value) => onClassChange(value || "")}
                    />
                </Col>
                <Col xs={12} sm={6} md={3} lg={2}>
                    <Form.Label className="mb-1" style={{ fontSize: 12, fontWeight: 600 }}>Section</Form.Label>
                    <SelectDropDown
                        name="analyticsSection"
                        placeholderName="All Sections"
                        options={sectionOptions}
                        stateData={selectedSectionOptions}
                        isMulti
                        handleChange={(name, values) => onSectionChange(values || [])}
                    />
                </Col>
                <Col xs={12} sm={6} md={3} lg={2}>
                    <Form.Label className="mb-1" style={{ fontSize: 12, fontWeight: 600 }}>Subject</Form.Label>
                    <SelectDropDown
                        name="analyticsSubject"
                        placeholderName="All Subjects"
                        options={subjectOptions}
                        stateData={subjectId ? subjectOptions.find((s) => String(s.value) === String(subjectId)) || null : null}
                        handleChange={(name, value) => onSubjectChange(value || "")}
                    />
                </Col>
                <Col xs={6} sm={4} md={2} lg={1}>
                    <Form.Label className="mb-1" style={{ fontSize: 12, fontWeight: 600 }}>Attendance</Form.Label>
                    <Form.Control as="select" size="sm" value={attendance} onChange={(e) => onAttendanceChange(e.target.value)}>
                        <option value="">All</option>
                        <option value="present">Present</option>
                        <option value="absent">Absent</option>
                    </Form.Control>
                </Col>
                <Col xs={6} sm={4} md={2} lg={1}>
                    <Form.Label className="mb-1" style={{ fontSize: 12, fontWeight: 600 }}>Result</Form.Label>
                    <Form.Control as="select" size="sm" value={passFail} onChange={(e) => onPassFailChange(e.target.value)}>
                        <option value="">All</option>
                        <option value="pass">Pass</option>
                        <option value="fail">Fail</option>
                    </Form.Control>
                </Col>
                <Col xs={12} sm={4} md={2} lg={2}>
                    <Form.Label className="mb-1" style={{ fontSize: 12, fontWeight: 600 }}>Quick View</Form.Label>
                    <Form.Control as="select" size="sm" value={quickFilter} onChange={(e) => onQuickFilterChange(e.target.value)}>
                        <option value="">All Students</option>
                        <option value="top">Top Performers</option>
                        <option value="lowest">Lowest Performers</option>
                    </Form.Control>
                </Col>
            </Row>

            <div className="d-flex justify-content-end mt-2" style={{ gap: 8 }}>
                <button type="button" className="btn btn-sm btn-outline-secondary" onClick={onExportCsv}>
                    <i className="fal fa-file-csv mr-1" /> CSV
                </button>
                <button type="button" className="btn btn-sm btn-outline-secondary" onClick={onExportExcel}>
                    <i className="fal fa-file-excel mr-1" /> Excel
                </button>
                <button type="button" className="btn btn-sm btn-outline-secondary" onClick={onPrint}>
                    <i className="fal fa-print mr-1" /> Print
                </button>
            </div>
        </div>
    );
}

export default AnalyticsFilters;
